module.exports = __webpack_public_path__ + "img/image_offline05@2x.2eb94fd6.png";